import { CollapsePanelProps } from '@app/types'
import { Collapse as AntCollapse } from 'antd'
import styled from 'styled-components'

const { Panel: AntCollapsePanel } = AntCollapse

const StyledCollapsePanel = styled(AntCollapsePanel)`
  .ant-collapse-header-text {
    flex: auto !important;
  }
`

export const CollapsePanel: React.FC<CollapsePanelProps> = (props) => <StyledCollapsePanel {...props} />
